/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

var props = {
  width: {
    type: String,
    "default": ""
  }
};

export { props as default };
//# sourceMappingURL=aside-props.mjs.map
